import { render } from "./JudgeCardList.vue?vue&type=template&id=1f90f9c2"
import script from "./JudgeCardList.vue?vue&type=script&lang=js"
export * from "./JudgeCardList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__